import { c as _c } from "react/compiler-runtime";
import { AboutSection } from "@/enums";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./About.module.scss";
export default function AboutTermsOfService() {
  const $ = _c(255);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>Terms Of Service</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Row><Col className={`${styles.lastUpdateText} text-right pt-3 pb-3`}>Last Updated: February 23, 2023</Col></Row>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <b>Abbreviations Make Documents More Readable</b>;
    t3 = <br />;
    t4 = <br />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <br />;
    t6 = <br />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <br />;
    t8 = <br />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t10;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <br />;
    t10 = <br />;
    $[9] = t10;
    $[10] = t9;
  } else {
    t10 = $[9];
    t9 = $[10];
  }
  let t11;
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <br />;
    t12 = <br />;
    $[11] = t11;
    $[12] = t12;
  } else {
    t11 = $[11];
    t12 = $[12];
  }
  let t13;
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <br />;
    t14 = <br />;
    $[13] = t13;
    $[14] = t14;
  } else {
    t13 = $[13];
    t14 = $[14];
  }
  let t15;
  let t16;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <br />;
    t16 = <br />;
    $[15] = t15;
    $[16] = t16;
  } else {
    t15 = $[15];
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Link href="https://6529.io" target="_blank" rel="noopener noreferrer">6529.io</Link>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Link href="https://6529.io" target="_blank" rel="noopener noreferrer">6529.io</Link>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  let t20;
  let t21;
  let t22;
  let t23;
  let t24;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <li>{t2}{t3}{t4}These are the abbreviations used in this document.{t5}{t6}"Terms": Terms of Service{t7}{t8}"We": 6529 Collection LLC{t9}{t10}"6529 NFTs": The Memes, 6529 Gradient, Meme Lab, GenMemes, 6529 Intern and other NFTs that may be added from time to time.{t11}{t12}"You": An adult, at least 18 years of age, who is not subject to sanctions by the US government.{t13}{t14}"Third Parties": Everyone else who is not "We" or "You"{t15}{t16}"Our Platform": the website located at{" "}{t17}{" "}, any websites hosted at sub-domains of{" "}{t18}{" "}, including hosted minting or primary sales pages, any primary mints or sales directly from our smart contracts, any mobile or metaverse applications we may make, and any content (data, descriptions or otherwise) on our website or decentralized file storage platforms like IPFS or Arweave.<br /><br />"Not Our Platform": Everything else that is not included in "Our Platform" including your Ethereum wallet, NFT marketplaces, and publicly accessible secondary functions on our smart contracts, such as token transfers.</li>;
    t20 = <br />;
    t21 = <br />;
    t22 = <b>The Underlying Principles Of These Terms</b>;
    t23 = <br />;
    t24 = <br />;
    $[19] = t19;
    $[20] = t20;
    $[21] = t21;
    $[22] = t22;
    $[23] = t23;
    $[24] = t24;
  } else {
    t19 = $[19];
    t20 = $[20];
    t21 = $[21];
    t22 = $[22];
    t23 = $[23];
    t24 = $[24];
  }
  let t25;
  let t26;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <br />;
    t26 = <br />;
    $[25] = t25;
    $[26] = t26;
  } else {
    t25 = $[25];
    t26 = $[26];
  }
  let t27;
  let t28;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <br />;
    t28 = <br />;
    $[27] = t27;
    $[28] = t28;
  } else {
    t27 = $[27];
    t28 = $[28];
  }
  let t29;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <br />;
    $[29] = t29;
  } else {
    t29 = $[29];
  }
  let t30;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <br />;
    $[30] = t30;
  } else {
    t30 = $[30];
  }
  let t31;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <br />;
    $[31] = t31;
  } else {
    t31 = $[31];
  }
  let t32;
  let t33;
  let t34;
  let t35;
  let t36;
  let t37;
  let t38;
  let t39;
  let t40;
  let t41;
  let t42;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <li>{t22}{t23}{t24}There are two underlying principles of these terms:{t25}{t26}<ol><li>Our main ongoing activity is primary minting CC0 NFTs (The Memes, Meme Lab, GenMemes are CC0) with a mission-based focus at fairly affordable prices.{t27}{t28}Once the NFTs have been primary minted:{t29}a) you and Third Parties can do whatever you want with the NFT{t30}and{t31}b) we do not have any further obligations toward you<br /><br />Most of the Clauses in the Terms relate to making (b) absolutely clear</li><br /><li>We do not have control of what someone does with The Memes, Meme Lab and GenMemes NFTs after minting, either at the level of the token or the art.</li></ol><br />"Our Platforms" provide a (hopefully) convenient way to see information about 6529 NFTs and their collectors and to primary mint NFTs, but they are not the token nor the art. We do not make any claims on the token post-minting or on the art for the CC0 6529 NFTs, nor do we take any responsibility for either.</li>;
    t33 = <br />;
    t34 = <li><b>Our Platform, Our House Rules I</b><br /><br />Agreeing to these terms is the only way you are allowed to use Our Platform. If you do not agree with our Terms, that is fine, but you cannot use Our Platform.</li>;
    t35 = <br />;
    t36 = <br />;
    t37 = <li><b>Our Platform, Our House Rules II</b><br /><br />We can terminate or pause your access to Our Platform at any time, for any reason.</li>;
    t38 = <br />;
    t39 = <br />;
    t40 = <b>Our Platform, Our House Rules III</b>;
    t41 = <br />;
    t42 = <br />;
    $[32] = t32;
    $[33] = t33;
    $[34] = t34;
    $[35] = t35;
    $[36] = t36;
    $[37] = t37;
    $[38] = t38;
    $[39] = t39;
    $[40] = t40;
    $[41] = t41;
    $[42] = t42;
  } else {
    t32 = $[32];
    t33 = $[33];
    t34 = $[34];
    t35 = $[35];
    t36 = $[36];
    t37 = $[37];
    t38 = $[38];
    t39 = $[39];
    t40 = $[40];
    t41 = $[41];
    t42 = $[42];
  }
  let t43;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Link href="https://x.com/punk6529" target="_blank" rel="noopener noreferrer">punk6529</Link>;
    $[43] = t43;
  } else {
    t43 = $[43];
  }
  let t44;
  let t45;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <br />;
    t45 = <br />;
    $[44] = t44;
    $[45] = t45;
  } else {
    t44 = $[44];
    t45 = $[45];
  }
  let t46;
  let t47;
  let t48;
  let t49;
  let t50;
  let t51;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <li>{t40}{t41}{t42}@{t43}{" "}tweets a lot and has a lot of ideas that may change from time to time.{t44}{t45}You should have no expectation whatsoever that what he (or other team members) are going to tweet or otherwise communicate is going to match your current or future understanding of the 6529 NFTs.<br /><br />His, or any other person or team member's, retweets, likes, twitter or discord communications, podcasts, essays or other communications are not endorsements nor do they reflect changes in Terms.</li>;
    t47 = <br />;
    t48 = <br />;
    t49 = <b>The Only Constant In This World Is Change I</b>;
    t50 = <br />;
    t51 = <br />;
    $[46] = t46;
    $[47] = t47;
    $[48] = t48;
    $[49] = t49;
    $[50] = t50;
    $[51] = t51;
  } else {
    t46 = $[46];
    t47 = $[47];
    t48 = $[48];
    t49 = $[49];
    t50 = $[50];
    t51 = $[51];
  }
  let t52;
  let t53;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <br />;
    t53 = <br />;
    $[52] = t52;
    $[53] = t53;
  } else {
    t52 = $[52];
    t53 = $[53];
  }
  let t54;
  let t55;
  let t56;
  let t57;
  let t58;
  let t59;
  let t60;
  let t61;
  let t62;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <li>{t49}{t50}{t51}The Terms and any pages or policies incorporated in the Terms by reference may change at any time. The changes are effective immediately.{t52}{t53}Any material change will be communicated by changing the "Last Updated" date on this webpage or any other method we choose.<br /><br />If you disagree with the changes, that is fine, but you cannot use Our Platform from that point onward.</li>;
    t55 = <br />;
    t56 = <br />;
    t57 = <li><b>The Only Constant In This World Is Change II</b><br /><br />We have the right to change or terminate any or all of our activities at any time for any reason.</li>;
    t58 = <br />;
    t59 = <br />;
    t60 = <b>We Are On A Mission</b>;
    t61 = <br />;
    t62 = <br />;
    $[54] = t54;
    $[55] = t55;
    $[56] = t56;
    $[57] = t57;
    $[58] = t58;
    $[59] = t59;
    $[60] = t60;
    $[61] = t61;
    $[62] = t62;
  } else {
    t54 = $[54];
    t55 = $[55];
    t56 = $[56];
    t57 = $[57];
    t58 = $[58];
    t59 = $[59];
    t60 = $[60];
    t61 = $[61];
    t62 = $[62];
  }
  let t63;
  let t64;
  let t65;
  let t66;
  let t67;
  let t68;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = <li>{t60}{t61}{t62}The mission of 6529 NFTs is to effectively make people aware of the importance of decentralization.<br /><br />If at any point in time, at our sole discretion, we think a change will improve the success of the mission, even if it may be disadvantageous to any other perceived goal of the 6529 NFTs, we will make that change and not think twice.</li>;
    t64 = <br />;
    t65 = <br />;
    t66 = <b>Read First, Participate Later</b>;
    t67 = <br />;
    t68 = <br />;
    $[63] = t63;
    $[64] = t64;
    $[65] = t65;
    $[66] = t66;
    $[67] = t67;
    $[68] = t68;
  } else {
    t63 = $[63];
    t64 = $[64];
    t65 = $[65];
    t66 = $[66];
    t67 = $[67];
    t68 = $[68];
  }
  let t69;
  let t70;
  let t71;
  let t72;
  let t73;
  let t74;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t69 = <li>{t66}{t67}{t68}You acknowledge that you have read and accept the information on the webpages and that is incorporated by reference into these Terms.<br /><br /><Link href={`/about/${AboutSection.MEMES}`} target="_blank" rel="noopener noreferrer">6529.io/about/{AboutSection.MEMES}</Link><br /><Link href={`/about/${AboutSection.GRADIENTS}`} target="_blank" rel="noopener noreferrer">6529.io/about/{AboutSection.GRADIENTS}</Link><br /><Link href={`/about/${AboutSection.MEME_LAB}`} target="_blank" rel="noopener noreferrer">6529.io/about/{AboutSection.MEME_LAB}</Link><br /><Link href={`/about/${AboutSection.FAQ}`} target="_blank" rel="noopener noreferrer">6529.io/about/{AboutSection.FAQ}</Link></li>;
    t70 = <br />;
    t71 = <br />;
    t72 = <b>License / IP</b>;
    t73 = <br />;
    t74 = <br />;
    $[69] = t69;
    $[70] = t70;
    $[71] = t71;
    $[72] = t72;
    $[73] = t73;
    $[74] = t74;
  } else {
    t69 = $[69];
    t70 = $[70];
    t71 = $[71];
    t72 = $[72];
    t73 = $[73];
    t74 = $[74];
  }
  let t75;
  let t76;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t75 = <br />;
    t76 = <br />;
    $[75] = t75;
    $[76] = t76;
  } else {
    t75 = $[75];
    t76 = $[76];
  }
  let t77;
  let t78;
  let t79;
  let t80;
  let t81;
  let t82;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = <li>{t72}{t73}{t74}Our NFTs do not transfer any IP rights to you.{t75}{t76}You acknowledge that you have read and accept the information on this webpage that explains this topic in more detail and that is incorporated by reference into these Terms.<br /><br /><Link href={`/about/${AboutSection.LICENSE}`} target="_blank" rel="noopener noreferrer">6529.io/about/{AboutSection.LICENSE}</Link></li>;
    t78 = <br />;
    t79 = <br />;
    t80 = <b>Minting NFTs</b>;
    t81 = <br />;
    t82 = <br />;
    $[77] = t77;
    $[78] = t78;
    $[79] = t79;
    $[80] = t80;
    $[81] = t81;
    $[82] = t82;
  } else {
    t77 = $[77];
    t78 = $[78];
    t79 = $[79];
    t80 = $[80];
    t81 = $[81];
    t82 = $[82];
  }
  let t83;
  let t84;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t83 = <br />;
    t84 = <br />;
    $[83] = t83;
    $[84] = t84;
  } else {
    t83 = $[83];
    t84 = $[84];
  }
  let t85;
  let t86;
  let t87;
  let t88;
  let t89;
  let t90;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t85 = <li>{t80}{t81}{t82}You have no right to receive (airdrop) or mint (allowlist) a future 6529 NFT based on owning one or more current 6529 NFTs.{t83}{t84}You acknowledge that you have read and accept the information on this webpage that explains this topic in more detail and that is incorporated by reference into these Terms.<br /><br /><Link href={`/about/${AboutSection.MINTING}`} target="_blank" rel="noopener noreferrer">6529.io/about/{AboutSection.MINTING}</Link></li>;
    t86 = <br />;
    t87 = <br />;
    t88 = <b>Privacy</b>;
    t89 = <br />;
    t90 = <br />;
    $[85] = t85;
    $[86] = t86;
    $[87] = t87;
    $[88] = t88;
    $[89] = t89;
    $[90] = t90;
  } else {
    t85 = $[85];
    t86 = $[86];
    t87 = $[87];
    t88 = $[88];
    t89 = $[89];
    t90 = $[90];
  }
  let t91;
  let t92;
  let t93;
  let t94;
  let t95;
  let t96;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t91 = <li>{t88}{t89}{t90}Our privacy policy can be found here. We may transfer or process data in the United States or other countries.<br /><br /><Link href={`/about/${AboutSection.PRIVACY_POLICY}`} target="_blank" rel="noopener noreferrer">6529.io/about/{AboutSection.PRIVACY_POLICY}</Link></li>;
    t92 = <br />;
    t93 = <br />;
    t94 = <b>Copyright</b>;
    t95 = <br />;
    t96 = <br />;
    $[91] = t91;
    $[92] = t92;
    $[93] = t93;
    $[94] = t94;
    $[95] = t95;
    $[96] = t96;
  } else {
    t91 = $[91];
    t92 = $[92];
    t93 = $[93];
    t94 = $[94];
    t95 = $[95];
    t96 = $[96];
  }
  let t100;
  let t101;
  let t102;
  let t97;
  let t98;
  let t99;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t97 = <li>{t94}{t95}{t96}Our Copyright policy can be found here<br /><br /><Link href={`/about/${AboutSection.COPYRIGHT}`} target="_blank" rel="noopener noreferrer">6529.io/about/{AboutSection.COPYRIGHT}</Link></li>;
    t98 = <br />;
    t99 = <br />;
    t100 = <b>Not Our Platform</b>;
    t101 = <br />;
    t102 = <br />;
    $[97] = t100;
    $[98] = t101;
    $[99] = t102;
    $[100] = t97;
    $[101] = t98;
    $[102] = t99;
  } else {
    t100 = $[97];
    t101 = $[98];
    t102 = $[99];
    t97 = $[100];
    t98 = $[101];
    t99 = $[102];
  }
  let t103;
  let t104;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t103 = <br />;
    t104 = <br />;
    $[103] = t103;
    $[104] = t104;
  } else {
    t103 = $[103];
    t104 = $[104];
  }
  let t105;
  let t106;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t105 = <br />;
    t106 = <br />;
    $[105] = t105;
    $[106] = t106;
  } else {
    t105 = $[105];
    t106 = $[106];
  }
  let t107;
  let t108;
  let t109;
  let t110;
  let t111;
  let t112;
  if ($[107] === Symbol.for("react.memo_cache_sentinel")) {
    t107 = <li>{t100}{t101}{t102}Due to the architecture of NFT contracts, 6529 NFTs can be transferred without our permission or consent. We cannot "freeze" someone's 6529 NFTs or transfer them to a party of our choosing. After the primary sale from us to you, you are in full control of your token.{t103}{t104}This means that you can transact 6529 NFTs in their Ethereum wallets, in marketplaces, in galleries, in metaverse platforms, in games and in a wide range of services that may emerge. All of these transactions are occurring on Not Our Platform. We have no ability to enforce or control transactions happening on Not Our Platform.{t105}{t106}We take absolutely no responsibility whatsoever for what you and Third Parties do on Not Our Platform, including but not limited to, suffering economic losses, security risks, theft, hacking, unpleasant consumer experiences, what commitments or representations are made as a part of those transactions, and if those transactions are legal in your jurisdiction.<br /><br />We are not a party to those transactions. We have a relationship with you when you use Our Platform only.</li>;
    t108 = <br />;
    t109 = <br />;
    t110 = <b>Many Things Can Go Wrong</b>;
    t111 = <br />;
    t112 = <br />;
    $[107] = t107;
    $[108] = t108;
    $[109] = t109;
    $[110] = t110;
    $[111] = t111;
    $[112] = t112;
  } else {
    t107 = $[107];
    t108 = $[108];
    t109 = $[109];
    t110 = $[110];
    t111 = $[111];
    t112 = $[112];
  }
  let t113;
  let t114;
  let t115;
  let t116;
  let t117;
  let t118;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t113 = <li>{t110}{t111}{t112}NFTs are the most volatile and experimental sector of the crypto field which itself is still a new, volatile and experimental field<br /><br />Many things can potentially go wrong with NFTs in general or 6529-related NFTs in particular, including but not limited to: (a) technical flaws/bugs/hacks/vulnerabilities at the protocol level, (b) changes at the protocol level, (c) changes in which protocols are popular, (d) technical flaws/bugs/hacks/vulnerabilities at the wallet level, (e) changes in the popularity of NFTs in general or any NFTs specifically, (f) technical flaws/bugs/hacks/vulnerabilities of project or marketplace websites, (g) technical flaws/bugs/hacks/vulnerabilities of general or project-related communication channels such as discord or twitter, (h) legal or regulatory changes or actions that impact specific NFTs (including ours) or all NFTs.</li>;
    t114 = <br />;
    t115 = <br />;
    t116 = <b>Future Value of 6529 NFTs</b>;
    t117 = <br />;
    t118 = <br />;
    $[113] = t113;
    $[114] = t114;
    $[115] = t115;
    $[116] = t116;
    $[117] = t117;
    $[118] = t118;
  } else {
    t113 = $[113];
    t114 = $[114];
    t115 = $[115];
    t116 = $[116];
    t117 = $[117];
    t118 = $[118];
  }
  let t119;
  let t120;
  let t121;
  let t122;
  let t123;
  let t124;
  if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
    t119 = <li>{t116}{t117}{t118}The future value of art and collectibles is based on demand and social factors, is impossible to forecast, and, in any case, is out of our control.<br /><br />We have no idea what the future value (if any) will be of 6529 NFTs.</li>;
    t120 = <br />;
    t121 = <br />;
    t122 = <b>Royalties</b>;
    t123 = <br />;
    t124 = <br />;
    $[119] = t119;
    $[120] = t120;
    $[121] = t121;
    $[122] = t122;
    $[123] = t123;
    $[124] = t124;
  } else {
    t119 = $[119];
    t120 = $[120];
    t121 = $[121];
    t122 = $[122];
    t123 = $[123];
    t124 = $[124];
  }
  let t125;
  let t126;
  let t127;
  let t128;
  let t129;
  let t130;
  if ($[125] === Symbol.for("react.memo_cache_sentinel")) {
    t125 = <li>{t122}{t123}{t124}Most 6529 NFTs have secondary sale royalties associated with them that are paid to us, the collaborating artist or both.<br /><br />While we have not done so, we reserve the right with no further notice to treat NFTs that have paid royalties differently than those that have not, in ways to be determined in the future.</li>;
    t126 = <br />;
    t127 = <br />;
    t128 = <b>CC0</b>;
    t129 = <br />;
    t130 = <br />;
    $[125] = t125;
    $[126] = t126;
    $[127] = t127;
    $[128] = t128;
    $[129] = t129;
    $[130] = t130;
  } else {
    t125 = $[125];
    t126 = $[126];
    t127 = $[127];
    t128 = $[128];
    t129 = $[129];
    t130 = $[130];
  }
  let t131;
  let t132;
  if ($[131] === Symbol.for("react.memo_cache_sentinel")) {
    t131 = <br />;
    t132 = <br />;
    $[131] = t131;
    $[132] = t132;
  } else {
    t131 = $[131];
    t132 = $[132];
  }
  let t133;
  let t134;
  let t135;
  let t136;
  let t137;
  let t138;
  if ($[133] === Symbol.for("react.memo_cache_sentinel")) {
    t133 = <li>{t128}{t129}{t130}Most 6529 NFTs are CC0 (Creative Commons 0) licensed which means they are in the public domain.{t131}{t132}This means anyone in the world can use the image associated with your NFT for any purpose they like. Some uses may be perceived by you as desirable and some uses may be perceived as undesirable or even shocking.<br /><br />This is the nature of CC0 art. There is nothing we or anyone else can do about it. If this bothers you, you should probably not buy a CC0 NFT.</li>;
    t134 = <br />;
    t135 = <br />;
    t136 = <b>Utility</b>;
    t137 = <br />;
    t138 = <br />;
    $[133] = t133;
    $[134] = t134;
    $[135] = t135;
    $[136] = t136;
    $[137] = t137;
    $[138] = t138;
  } else {
    t133 = $[133];
    t134 = $[134];
    t135 = $[135];
    t136 = $[136];
    t137 = $[137];
    t138 = $[138];
  }
  let t139;
  let t140;
  if ($[139] === Symbol.for("react.memo_cache_sentinel")) {
    t139 = <br />;
    t140 = <br />;
    $[139] = t139;
    $[140] = t140;
  } else {
    t139 = $[139];
    t140 = $[140];
  }
  let t141;
  let t142;
  let t143;
  let t144;
  let t145;
  let t146;
  if ($[141] === Symbol.for("react.memo_cache_sentinel")) {
    t141 = <li>{t136}{t137}{t138}6529 NFTs do not have any "utility" beyond being works of art.{t139}{t140}We may, from time to time, test or operate services that interoperate with 6529 NFTs.<br /><br />These should be considered experimental, subject to change, subject to being terminated and, in any case, not changing the general principle that we make no commitments to offering "utility" to owners of 6529 NFTs.</li>;
    t142 = <br />;
    t143 = <br />;
    t144 = <b>Third Party Perspectives</b>;
    t145 = <br />;
    t146 = <br />;
    $[141] = t141;
    $[142] = t142;
    $[143] = t143;
    $[144] = t144;
    $[145] = t145;
    $[146] = t146;
  } else {
    t141 = $[141];
    t142 = $[142];
    t143 = $[143];
    t144 = $[144];
    t145 = $[145];
    t146 = $[146];
  }
  let t147;
  let t148;
  let t149;
  let t150;
  let t151;
  let t152;
  if ($[147] === Symbol.for("react.memo_cache_sentinel")) {
    t147 = <li>{t144}{t145}{t146}Many Third Parties have perspectives about 6529 NFTs that they share on social media and otherwise.<br /><br />We take no responsibility for these communications, whether we agree with them or not, as we have no way to monitor or exercise control over them.</li>;
    t148 = <br />;
    t149 = <br />;
    t150 = <b>Delegation and Consolidation</b>;
    t151 = <br />;
    t152 = <br />;
    $[147] = t147;
    $[148] = t148;
    $[149] = t149;
    $[150] = t150;
    $[151] = t151;
    $[152] = t152;
  } else {
    t147 = $[147];
    t148 = $[148];
    t149 = $[149];
    t150 = $[150];
    t151 = $[151];
    t152 = $[152];
  }
  let t153;
  let t154;
  let t155;
  let t156;
  let t157;
  let t158;
  if ($[153] === Symbol.for("react.memo_cache_sentinel")) {
    t153 = <li>{t150}{t151}{t152}We may provide from time to time the ability to delegate minting from one wallet to another, or to consolidate wallet contents for minting purposes. We take no responsibilities for errors, losses or missed opportunities relating to air drops or allowlist based on delegation or consolidation (or for any other reason).<br /><br />What formula or platform we use for delegation or consolidation (or whether we offer this functionality at all) is in our sole discretion.</li>;
    t154 = <br />;
    t155 = <br />;
    t156 = <b>Sanctions</b>;
    t157 = <br />;
    t158 = <br />;
    $[153] = t153;
    $[154] = t154;
    $[155] = t155;
    $[156] = t156;
    $[157] = t157;
    $[158] = t158;
  } else {
    t153 = $[153];
    t154 = $[154];
    t155 = $[155];
    t156 = $[156];
    t157 = $[157];
    t158 = $[158];
  }
  let t159;
  let t160;
  if ($[159] === Symbol.for("react.memo_cache_sentinel")) {
    t159 = <br />;
    t160 = <br />;
    $[159] = t159;
    $[160] = t160;
  } else {
    t159 = $[159];
    t160 = $[160];
  }
  let t161;
  let t162;
  let t163;
  let t164;
  let t165;
  let t166;
  if ($[161] === Symbol.for("react.memo_cache_sentinel")) {
    t161 = <li>{t156}{t157}{t158}The United States makes it illegal to engage in economic transactions with certain people or entities ("Sanctioned Parties"){t159}{t160}As we prefer not to go to jail, if you are a Sanctioned Party, we cannot engage in any economic activities with you.<br /><br />If you are a Sanctioned Party, please do not: a) mint a 6529 NFT, b) apply to be a Meme Card artist, or c) send us any ETH, for royalties or otherwise.</li>;
    t162 = <br />;
    t163 = <br />;
    t164 = <b>We Are Not Your Personal Ethereum Concierge</b>;
    t165 = <br />;
    t166 = <br />;
    $[161] = t161;
    $[162] = t162;
    $[163] = t163;
    $[164] = t164;
    $[165] = t165;
    $[166] = t166;
  } else {
    t161 = $[161];
    t162 = $[162];
    t163 = $[163];
    t164 = $[164];
    t165 = $[165];
    t166 = $[166];
  }
  let t167;
  let t168;
  if ($[167] === Symbol.for("react.memo_cache_sentinel")) {
    t167 = <br />;
    t168 = <br />;
    $[167] = t167;
    $[168] = t168;
  } else {
    t167 = $[167];
    t168 = $[168];
  }
  let t169;
  let t170;
  let t171;
  let t172;
  let t173;
  let t174;
  if ($[169] === Symbol.for("react.memo_cache_sentinel")) {
    t169 = <li>{t164}{t165}{t166}NFTs are held in self-managed Ethereum wallets where the users are responsible for authorizing transactions.{t167}{t168}Mistakes in how an Ethereum wallet is used can lead to loss of your 6529 NFTs (or other tokens), failed transactions or high gas costs. Such events are your responsibility and out of our control and we cannot offer you compensation or any other recourse for such events.<br /><br />There is a vast array of educational resources available to learn about how to use Ethereum well. We encourage you to study and practice with small amounts before buying economically meaningful NFTs and to follow good safety practices such as using multi-signature or hardware wallets.</li>;
    t170 = <br />;
    t171 = <br />;
    t172 = <b>Phishing</b>;
    t173 = <br />;
    t174 = <br />;
    $[169] = t169;
    $[170] = t170;
    $[171] = t171;
    $[172] = t172;
    $[173] = t173;
    $[174] = t174;
  } else {
    t169 = $[169];
    t170 = $[170];
    t171 = $[171];
    t172 = $[172];
    t173 = $[173];
    t174 = $[174];
  }
  let t175;
  let t176;
  if ($[175] === Symbol.for("react.memo_cache_sentinel")) {
    t175 = <br />;
    t176 = <br />;
    $[175] = t175;
    $[176] = t176;
  } else {
    t175 = $[175];
    t176 = $[176];
  }
  let t177;
  let t178;
  let t179;
  let t180;
  let t181;
  let t182;
  if ($[177] === Symbol.for("react.memo_cache_sentinel")) {
    t177 = <li>{t172}{t173}{t174}It is common for Third Parties to create fake 6529 websites in order to convince people to sign malicious transactions or transfer their private keys.{t175}{t176}We take no responsibility for phishing sites, even if we are made aware of them, and cannot provide any compensation or assistance for phishing, thefts or other related matters.<br /><br />It is your responsibility to understand which transactions you are signing in your Ethereum wallet.</li>;
    t178 = <br />;
    t179 = <br />;
    t180 = <b>Ethereum NFTs</b>;
    t181 = <br />;
    t182 = <br />;
    $[177] = t177;
    $[178] = t178;
    $[179] = t179;
    $[180] = t180;
    $[181] = t181;
    $[182] = t182;
  } else {
    t177 = $[177];
    t178 = $[178];
    t179 = $[179];
    t180 = $[180];
    t181 = $[181];
    t182 = $[182];
  }
  let t183;
  let t184;
  let t185;
  let t186;
  let t187;
  let t188;
  if ($[183] === Symbol.for("react.memo_cache_sentinel")) {
    t183 = <li>{t180}{t181}{t182}The 6529 NFTs are currently only available on the Ethereum blockchain.<br /><br />Moving them to another blockchain including an "L2" Ethereum blockchain will lead to their loss.</li>;
    t184 = <br />;
    t185 = <br />;
    t186 = <b>We Might Get Hacked</b>;
    t187 = <br />;
    t188 = <br />;
    $[183] = t183;
    $[184] = t184;
    $[185] = t185;
    $[186] = t186;
    $[187] = t187;
    $[188] = t188;
  } else {
    t183 = $[183];
    t184 = $[184];
    t185 = $[185];
    t186 = $[186];
    t187 = $[187];
    t188 = $[188];
  }
  let t189;
  let t190;
  if ($[189] === Symbol.for("react.memo_cache_sentinel")) {
    t189 = <br />;
    t190 = <br />;
    $[189] = t189;
    $[190] = t190;
  } else {
    t189 = $[189];
    t190 = $[190];
  }
  let t191;
  let t192;
  let t193;
  let t194;
  let t195;
  let t196;
  if ($[191] === Symbol.for("react.memo_cache_sentinel")) {
    t191 = <li>{t186}{t187}{t188}It is possible that Our Platform may be hacked or otherwise maliciously attacked and we disclaim any liability in this case.{t189}{t190}You remain solely responsible for any actions you take relating to Our Platform, including signing transactions from your Ethereum wallet.<br /><br />Always keep your guard up for suspicious behavior even on trusted sites.</li>;
    t192 = <br />;
    t193 = <br />;
    t194 = <b>Your Feedback and Ideas</b>;
    t195 = <br />;
    t196 = <br />;
    $[191] = t191;
    $[192] = t192;
    $[193] = t193;
    $[194] = t194;
    $[195] = t195;
    $[196] = t196;
  } else {
    t191 = $[191];
    t192 = $[192];
    t193 = $[193];
    t194 = $[194];
    t195 = $[195];
    t196 = $[196];
  }
  let t197;
  let t198;
  if ($[197] === Symbol.for("react.memo_cache_sentinel")) {
    t197 = <br />;
    t198 = <br />;
    $[197] = t197;
    $[198] = t198;
  } else {
    t197 = $[197];
    t198 = $[198];
  }
  let t199;
  let t200;
  let t201;
  let t202;
  let t203;
  let t204;
  if ($[199] === Symbol.for("react.memo_cache_sentinel")) {
    t199 = <li>{t194}{t195}{t196}You can feel free to share ideas with us, but we may use them or may already be working on similar ideas.{t197}{t198}Given this, we will not pay you and you cannot claim compensation for "sharing ideas". If this is not acceptable to you, do not share your ideas with us.<br /><br />We will not sign NDAs or non-competes to hear your ideas.</li>;
    t200 = <br />;
    t201 = <br />;
    t202 = <b>Third Party Content or Services</b>;
    t203 = <br />;
    t204 = <br />;
    $[199] = t199;
    $[200] = t200;
    $[201] = t201;
    $[202] = t202;
    $[203] = t203;
    $[204] = t204;
  } else {
    t199 = $[199];
    t200 = $[200];
    t201 = $[201];
    t202 = $[202];
    t203 = $[203];
    t204 = $[204];
  }
  let t205;
  let t206;
  let t207;
  let t208;
  let t209;
  let t210;
  if ($[205] === Symbol.for("react.memo_cache_sentinel")) {
    t205 = <li>{t202}{t203}{t204}We may link to or incorporate Third Party Content or Services. Your relationship with those Third Parties is directly with them.<br /><br />We do not provide any warranties, endorsements or representations relating to Third Party Content or Services and you interact with them at your sole risk.</li>;
    t206 = <br />;
    t207 = <br />;
    t208 = <b>You Can't Sue Us, Either Individually Or In Large Groups</b>;
    t209 = <br />;
    t210 = <br />;
    $[205] = t205;
    $[206] = t206;
    $[207] = t207;
    $[208] = t208;
    $[209] = t209;
    $[210] = t210;
  } else {
    t205 = $[205];
    t206 = $[206];
    t207 = $[207];
    t208 = $[208];
    t209 = $[209];
    t210 = $[210];
  }
  let t211;
  let t212;
  if ($[211] === Symbol.for("react.memo_cache_sentinel")) {
    t211 = <br />;
    t212 = <br />;
    $[211] = t211;
    $[212] = t212;
  } else {
    t211 = $[211];
    t212 = $[212];
  }
  let t213;
  let t214;
  if ($[213] === Symbol.for("react.memo_cache_sentinel")) {
    t213 = <br />;
    t214 = <br />;
    $[213] = t213;
    $[214] = t214;
  } else {
    t213 = $[213];
    t214 = $[214];
  }
  let t215;
  let t216;
  if ($[215] === Symbol.for("react.memo_cache_sentinel")) {
    t215 = <br />;
    t216 = <br />;
    $[215] = t215;
    $[216] = t216;
  } else {
    t215 = $[215];
    t216 = $[216];
  }
  let t217;
  let t218;
  if ($[217] === Symbol.for("react.memo_cache_sentinel")) {
    t217 = <br />;
    t218 = <br />;
    $[217] = t217;
    $[218] = t218;
  } else {
    t217 = $[217];
    t218 = $[218];
  }
  let t219;
  let t220;
  let t221;
  let t222;
  let t223;
  let t224;
  if ($[219] === Symbol.for("react.memo_cache_sentinel")) {
    t219 = <li>{t208}{t209}{t210}You waive your right to sue us or to participate in a class action suit and agree to mandatory arbitration in the event of a dispute.{t211}{t212}Specifically, you agree to the following as it relates to disputes between you and us:{t213}{t214}a) That any dispute we might have, it is individual between you and us and you will not bring a class action, class arbitration or any other collective proceeding.{t215}{t216}b) If you or we have a dispute, we will aim to resolve it amicably first and, if that is not possible, either party will have the right to initiate a JAMS arbitration under standard JAMS terms of reference.{t217}{t218}You acknowledge that you have read and accept the information on this webpage that includes the applicable JAMS terms and that is incorporated by reference into these Terms.<br /><br /><Link href="/dispute-resolution" target="_blank" rel="noopener noreferrer">6529.io/dispute-resolution</Link>{" "}</li>;
    t220 = <br />;
    t221 = <br />;
    t222 = <b>Indemnification</b>;
    t223 = <br />;
    t224 = <br />;
    $[219] = t219;
    $[220] = t220;
    $[221] = t221;
    $[222] = t222;
    $[223] = t223;
    $[224] = t224;
  } else {
    t219 = $[219];
    t220 = $[220];
    t221 = $[221];
    t222 = $[222];
    t223 = $[223];
    t224 = $[224];
  }
  let t225;
  if ($[225] === Symbol.for("react.memo_cache_sentinel")) {
    t225 = <br />;
    $[225] = t225;
  } else {
    t225 = $[225];
  }
  let t226;
  if ($[226] === Symbol.for("react.memo_cache_sentinel")) {
    t226 = <br />;
    $[226] = t226;
  } else {
    t226 = $[226];
  }
  let t227;
  if ($[227] === Symbol.for("react.memo_cache_sentinel")) {
    t227 = <br />;
    $[227] = t227;
  } else {
    t227 = $[227];
  }
  let t228;
  if ($[228] === Symbol.for("react.memo_cache_sentinel")) {
    t228 = <br />;
    $[228] = t228;
  } else {
    t228 = $[228];
  }
  let t229;
  if ($[229] === Symbol.for("react.memo_cache_sentinel")) {
    t229 = <br />;
    $[229] = t229;
  } else {
    t229 = $[229];
  }
  let t230;
  if ($[230] === Symbol.for("react.memo_cache_sentinel")) {
    t230 = <br />;
    $[230] = t230;
  } else {
    t230 = $[230];
  }
  let t231;
  if ($[231] === Symbol.for("react.memo_cache_sentinel")) {
    t231 = <br />;
    $[231] = t231;
  } else {
    t231 = $[231];
  }
  let t232;
  if ($[232] === Symbol.for("react.memo_cache_sentinel")) {
    t232 = <br />;
    $[232] = t232;
  } else {
    t232 = $[232];
  }
  let t233;
  let t234;
  let t235;
  let t236;
  let t237;
  let t238;
  if ($[233] === Symbol.for("react.memo_cache_sentinel")) {
    t233 = <li>{t222}{t223}{t224}You agree to indemnify us and our subsidiaries, affiliates, managers, members, officers, partners, service providers and employees (together "6529 Parties") from losses, liabilities, claims, demands, damages, expenses or costs ("Claims") arising out of or related to:{t225}a. Your access to or use of Our Platform{t226}b. Your access to or use of Not Our Platform{t227}c. Your use of 6529 NFTs{t228}d. Your Violation of Terms{t229}e. Your Infringement of intellectual property, privacy, property rights of others{t230}f. Your Conduct{t231}g. Your Violation of Laws/Regulations{t232}h. Your Feedback And Ideas<br /><br />You will cooperate with the 6529 Parties in defending any such third-party Claims and pay all fees, costs and expenses associated with defending such Claims (including, but not limited to, attorneys' fees). 6529 Parties will have control of the defense or settlement, at 6529 Parties' sole option, of any third-party Claims.</li>;
    t234 = <br />;
    t235 = <br />;
    t236 = <b>Disclaimers</b>;
    t237 = <br />;
    t238 = <br />;
    $[233] = t233;
    $[234] = t234;
    $[235] = t235;
    $[236] = t236;
    $[237] = t237;
    $[238] = t238;
  } else {
    t233 = $[233];
    t234 = $[234];
    t235 = $[235];
    t236 = $[236];
    t237 = $[237];
    t238 = $[238];
  }
  let t239;
  let t240;
  let t241;
  let t242;
  let t243;
  let t244;
  let t245;
  let t246;
  let t247;
  if ($[239] === Symbol.for("react.memo_cache_sentinel")) {
    t239 = <li>{t236}{t237}{t238}Our Platform, the 6529 NFTs and any services relating to them are provided "As Is" and "As Available" without warranties of any kind, either express or implied, including warranties of merchantability, fitness for a particular purpose, title and non-infringement. We do not warrant that Our Platform, NFTs or communication and content relating to them is accurate, complete or error-free.<br /><br />We further reiterate the disclaimers, without limitation, in Clauses #10, #11, #13 to #25 and #27</li>;
    t240 = <br />;
    t241 = <br />;
    t242 = <li><b>Disclaimer of Damages</b><br /><br />To the fullest extent permitted by applicable law, we will not be liable to you under any theory of liability - whether based in contract, tort, negligence, strict liability, warranty or otherwise - for any indirect, consequential, exemplary, incidental, punitive or special damages or lost profits, even if we have been advised of the possibility of such damages.</li>;
    t243 = <br />;
    t244 = <br />;
    t245 = <b>Limitation of Liability</b>;
    t246 = <br />;
    t247 = <br />;
    $[239] = t239;
    $[240] = t240;
    $[241] = t241;
    $[242] = t242;
    $[243] = t243;
    $[244] = t244;
    $[245] = t245;
    $[246] = t246;
    $[247] = t247;
  } else {
    t239 = $[239];
    t240 = $[240];
    t241 = $[241];
    t242 = $[242];
    t243 = $[243];
    t244 = $[244];
    t245 = $[245];
    t246 = $[246];
    t247 = $[247];
  }
  let t248;
  let t249;
  let t250;
  let t251;
  let t252;
  let t253;
  if ($[248] === Symbol.for("react.memo_cache_sentinel")) {
    t248 = <li>{t245}{t246}{t247}Our total liability for any claim arising from use of our Platform or 6529 NFTs or these Terms is limited to the greater of $100 or the amount paid by you to us.<br /><br />The limitations in #31 and #32 will not limit or exclude liability for our gross negligence, fraud, or intentional misconduct or for any other matters which cannot be excluded or limited under applicable law. Some jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, so the above limitations or exclusions may not apply to you.</li>;
    t249 = <br />;
    t250 = <br />;
    t251 = <b>Release</b>;
    t252 = <br />;
    t253 = <br />;
    $[248] = t248;
    $[249] = t249;
    $[250] = t250;
    $[251] = t251;
    $[252] = t252;
    $[253] = t253;
  } else {
    t248 = $[248];
    t249 = $[249];
    t250 = $[250];
    t251 = $[251];
    t252 = $[252];
    t253 = $[253];
  }
  let t254;
  if ($[254] === Symbol.for("react.memo_cache_sentinel")) {
    t254 = <Container>{t0}{t1}<Row className="pt-3 pb-3"><Col><ol>{t19}{t20}{t21}{t32}{t33}{t34}{t35}{t36}{t37}{t38}{t39}{t46}{t47}{t48}{t54}{t55}{t56}{t57}{t58}{t59}{t63}{t64}{t65}{t69}{t70}{t71}{t77}{t78}{t79}{t85}{t86}{t87}{t91}{t92}{t93}{t97}{t98}{t99}{t107}{t108}{t109}{t113}{t114}{t115}{t119}{t120}{t121}{t125}{t126}{t127}{t133}{t134}{t135}{t141}{t142}{t143}{t147}{t148}{t149}{t153}{t154}{t155}{t161}{t162}{t163}{t169}{t170}{t171}{t177}{t178}{t179}{t183}{t184}{t185}{t191}{t192}{t193}{t199}{t200}{t201}{t205}{t206}{t207}{t219}{t220}{t221}{t233}{t234}{t235}{t239}{t240}{t241}{t242}{t243}{t244}{t248}{t249}{t250}<li>{t251}{t252}{t253}To the fullest extent permitted by applicable law, you release the 6529 Parties from responsibility, liability, claims, demands and/or damages (actual and consequential) of every kind and nature, known and unknown (including, but not limited to, claims of negligence), arising out of or related to disputes between users, acts or omissions of Third Parties or anything for which you have agreed that we will have no responsibility or liability pursuant to these terms.<br /><br />If you are a consumer who resides in California, you hereby waive your rights under California Civil Code § 1542, which provides: "A general release does not extend to claims that the creditor or releasing party does not know or suspect to exist in his or her favor at the time of executing the release and that, if known by him or her, would have materially affected his or her settlement with the debtor or released party."</li><br /><br /><li><b>Governing Law and Venue</b><br /><br />Any dispute arising from these Terms and your use of our Services will be governed by and construed and enforced in accordance with the laws of New York without regard to conflict of law rules or principles. Any dispute that is not subject to Arbitration will be resolved in the federal or state courts located in Wilmington, Delaware.</li><br /><br /><li><b>Failure To Enforce</b><br /><br />If we fail to enforce some of our rights under these Terms in the present or against certain parties, that does not mean they terminate or are waived. We reserve the right to enforce them in the future against any or all parties.</li><br /><br /><li><b>Section Titles</b><br /><br />Our section titles are for readability and have no legal or contractual effect.</li><br /><br /><li><b>Electronic Communication</b><br /><br />You consent to electronic communication and transactions.</li><br /><br /><li><b>Severability</b><br /><br />This means that if a certain section of these Terms is determined in some or all jurisdictions to be void, illegal or unenforceable, it will be severed from the rest of these Terms and the remainder of the contract will continue to be valid and binding.</li><br /><br /><li><b>Transferability</b><br /><br />We can transfer, delegate or assign our rights under this Terms without your consent. You must obtain our written consent to transfer, assign or delegate your rights under these Terms.</li></ol></Col></Row></Container>;
    $[254] = t254;
  } else {
    t254 = $[254];
  }
  return t254;
}